(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // 透明标头功能 - 修复鼠标交互问题
  class TransparentHeader {
    constructor() {
      this.headerWrapper = document.getElementById('main-header-wrapper');
      this.isHomeOrCollection = window.location.pathname === '/' || (window.location.pathname.startsWith('/collections/') && window.location.pathname !== '/collections/all');
      this.scrollThreshold = 10;
      this.menuDrawer = document.querySelector('header-drawer');
      this.previousScrollY = 0; // 新增：存储上一次滚动位置
      this.timer = null; // 新增：防抖定时器
      
      if (!this.headerWrapper || !this.isHomeOrCollection) return;
      
      this.init();
    }
    
    init() {
      // 初始化样式
      this.setStyle();
      
      // 滚动事件监听
      window.addEventListener('scroll', this.handleScroll.bind(this));
      
      // 窗口大小调整监听
      window.addEventListener('resize', this.handleResize.bind(this));
      
      // 桌面端鼠标事件
      if (window.innerWidth >= 750) {
        this.headerWrapper.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        this.headerWrapper.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      }
      
      // 移动端菜单事件
      if (this.menuDrawer) {
        this.menuDrawer.addEventListener('toggle', this.handleMenuToggle.bind(this));
      }
    }
    
    handleResize() {
      // 更新页面类型判断
      this.isHomeOrCollection = window.location.pathname === '/' || (window.location.pathname.startsWith('/collections/') && window.location.pathname !== '/collections/all');
      
      // 如果当前是首页或产品页，移除透明header类名
      if (this.isHomeOrCollection) {
        this.headerWrapper.classList.remove('transparent-header');
      }
    }
    
    handleScroll() {
      if (!this.isHomeOrCollection) return;
      
      this.checkScrollPosition();
    }
    
    handleMouseEnter() {
      // 防止频繁触发滚动事件时干扰
      clearTimeout(this.timer);
      
      // 改为直接添加类名，不再依赖定时器
      this.headerWrapper.classList.remove('transparent-header');
    }
    
    handleMouseLeave() {
      clearTimeout(this.timer);
      
      // 设置防抖延迟
      this.timer = setTimeout(() => {
        this.checkScrollPosition();
      }, 200);
    }
    
    handleMenuToggle(event) {
      if (event.target.open) {
        this.headerWrapper.classList.add('menu-open');
      } else {
        this.headerWrapper.classList.remove('menu-open');
      }
    }
    
    checkScrollPosition() {
      const scrollY = window.scrollY || window.pageYOffset;
      const scrolled = scrollY > this.scrollThreshold;
      
      if (scrolled) {
        this.headerWrapper.classList.add('scrolled');
      } else {
        this.headerWrapper.classList.remove('scrolled');
        
        // 如果鼠标不在header内，才恢复透明
        if (!this.headerWrapper.matches(':hover')) {
          this.headerWrapper.classList.add('transparent-header');
        }
      }
    }
    
    setStyle() {
      // 动态设置变量，确保兼容不同主题
      document.documentElement.style.setProperty('--color-background', getComputedStyle(document.documentElement).getPropertyValue('--color-background').trim());
      document.documentElement.style.setProperty('--alpha-background', '1');
    }
  }
  
  // 初始化透明标头功能
  document.addEventListener('DOMContentLoaded', () => {
    new TransparentHeader();
  });

  // 原始StickyHeader类保持不变
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
